import React from 'react'
import styles from '../styles/promptDialog.module.scss'
import Dialog from '@/wmCompoments/dialog'
import { useTranslation } from 'react-i18next'

interface Props {
    visible: boolean
    onClose?: () => void
    onSubmit?: () => Promise<any>
    message?: string
    showHead?: boolean
}

const PromptDialog = (props: Props) => {
    const { t } = useTranslation('transferCenter')
    const { visible, onClose, onSubmit, message, showHead } = props

    return (
        <>
            <Dialog
                visible={visible}
                closeOnMaskClick={true}
                onClose={() => {
                    onClose?.()
                }}
                actions={[

                    {
                        key: 'cancel',
                        text: t('cancel'),
                        onClick: () => {
                            onClose?.()
                        }
                    },
                    {
                        key: 'confirm',
                        text: t('confirm'),
                        onClick: async () => {
                            await onSubmit?.()
                            onClose?.()
                        }
                    }

                ]}
                content={
                    <div className={styles.warpper}>
                        {showHead && <div>
                            {t('tip')}
                        </div>}
                        <div>
                            {message}
                        </div>
                    </div>
                }
            />
        </>
    )
}

export default PromptDialog
